"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conceptFragment = void 0;
var _fetching = require("@ori/fetching");
var _shade = require("./shade");
const conceptFragment = exports.conceptFragment = (0, _fetching.gql)`
  ${_shade.searchPreviewShade}
  fragment BaseConcept on Concept {
    name
    brand {
      name
    }
    categories {
      name
    }
    products {
      ...SearchPreviewShade
    }
    labels {
      ...ProductLabels
    }
  }
`;
